import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'jquery/dist/jquery.min.js';
import '../../Styles/Analysen Request/lvanalysestatus.css';
import uuid from 'react-uuid';


function LogsComponent(props) {

    const [logs, setLogs] = useState([]);

    useEffect(() => {
        let count = 1;
        const loggings = props.logs.output.map(e => <div key={uuid()}>
            [{e.timestamp}] INFO:{count++}/{e.size} with ROW ID {e.row_id} has been processed
            <br /> <br />
        </div>);
        setLogs(loggings);
    }, [logs]);

    return (<>
        <div className='row'>
            <div className='console-type card col-md-12'>
                {logs}
            </div>
        </div>

    </>);
}

export default LogsComponent;